import React from "react";
import { StarRounded } from "@mui/icons-material";
import "./WinnerTicker.css";

export default function WinnerTicker({ winnerDetails = [] }) {
  const repeatedWinners = [...winnerDetails, ...winnerDetails];

  return (
    <div className="winner-ticker-container">
      <div className="winner-ticker-track">
        {repeatedWinners.map((winner, index) => (
          <div className="winner-ticker-item" key={`${winner.blogTitle}-${index}`}>
            <StarRounded className="winner-icon" />
            <span className="winner-text">
              <span className="winner-label">{winner.month} Top Blog · </span>
              <strong>{winner.winnerName}</strong> - "
              <a
                href={winner.blogLink}
                target="_blank"
                rel="noopener noreferrer"
                className="winner-link"
              >
                {winner.blogTitle}
              </a>
              "
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
